// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

.ant-menu-item {
  white-space: normal !important;
  height: auto !important;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* App.css */
.login-form {
  max-width: 300px;
}

.login-form .login-form-forgot {
  float: right;
}

.ant-col-rtl .login-form .login-form-forgot {
  float: left;
}

.login-form .login-form-button {
  width: 100%;
}

.mainContainer {
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.inputContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.inputBox {
  height: 48px;
  width: 400px;
  font-size: large;
  border-radius: 8px;
  border: 1px solid grey;
  padding-left: 8px;
}

/* Typing indicator animation */
.typing-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.typing-indicator span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #1890ff;
  animation: typing 1.4s infinite ease-in-out;
}

.typing-indicator span:nth-child(1) {
  animation-delay: -0.32s;
}

.typing-indicator span:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes typing {
  0%, 80%, 100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Card hover effects */
.ant-card {
  transition: all 0.3s ease;
}

.ant-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1) !important;
}

/* Course selection card animations */
.course-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.course-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;
}

/* Smooth scrolling */
html {
  scroll-behavior: smooth;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Button animations */
.ant-btn {
  transition: all 0.3s ease;
}

.ant-btn:hover {
  transform: translateY(-1px);
}

/* Responsive improvements */
@media (max-width: 768px) {
  .ant-card {
    margin-bottom: 16px;
  }
  
  .ant-space-item {
    margin-bottom: 8px !important;
  }
}

/* Gradient text effect */
.gradient-text {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Loading shimmer effect */
.shimmer {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

/* Enhanced menu styles */
.ant-menu-dark .ant-menu-item-selected {
  background-color: rgba(24, 144, 255, 0.2) !important;
  border-radius: 6px;
  margin: 4px 8px;
  width: calc(100% - 16px);
}

.ant-menu-dark .ant-menu-item {
  margin: 2px 8px;
  width: calc(100% - 16px);
  border-radius: 6px;
  transition: all 0.3s ease;
}

.ant-menu-dark .ant-menu-item:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

/* Progress bar enhancements */
.ant-progress-bg {
  transition: all 0.3s ease;
}

/* Enhanced breadcrumb */
.ant-breadcrumb a {
  transition: color 0.3s ease;
}

.ant-breadcrumb a:hover {
  color: #1890ff !important;
}

/* Card content spacing */
.ant-card-body p:last-child {
  margin-bottom: 0;
}

/* Enhanced select dropdown */
.ant-select-dropdown {
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

/* Enhanced input focus */
.ant-input:focus,
.ant-input-focused {
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

/* Enhanced button group */
.ant-btn-group .ant-btn {
  margin-right: 8px;
}

.ant-btn-group .ant-btn:last-child {
  margin-right: 0;
}

/* 重新生成按钮样式 */
.ant-card-extra .ant-btn {
  transition: all 0.3s ease;
}

.ant-card-extra .ant-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* 聊天卡片悬停效果 */
.ant-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;
  transform: translateY(-2px);
  transition: all 0.3s ease;
}

/* 用户消息卡片样式 */
.ant-card[style*="background: #f6ffed"] {
  border-left: 4px solid #52c41a;
  transition: all 0.3s ease;
}

.ant-card[style*="background: #f6ffed"]:hover {
  border-left-width: 6px;
  transform: translateX(2px);
}

/* AI回复卡片样式 */
.ant-card[style*="border: 1px solid #f0f0f0"] {
  border-left: 4px solid #1890ff;
  transition: all 0.3s ease;
}

.ant-card[style*="border: 1px solid #f0f0f0"]:hover {
  border-left-width: 6px;
  transform: translateX(2px);
}

/* 问题输入区域样式 */
.ant-card[style*="border: 2px dashed #d9d9d9"] {
  transition: all 0.3s ease;
}

.ant-card[style*="border: 2px dashed #d9d9d9"]:hover {
  border-color: #1890ff;
  background: #f0f8ff !important;
}

/* 自动保存按钮样式 */
.ant-btn[style*="color: #52c41a"] {
  border-color: #52c41a;
  background: rgba(82, 196, 26, 0.1);
}

/* 控制面板样式增强 */
.ant-card[style*="marginBottom: 24"] {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border: none;
}

/* 响应式改进 */
@media (max-width: 768px) {
  .ant-card-extra {
    margin-top: 8px;
  }
  
  .ant-card-extra .ant-space {
    flex-direction: column;
    gap: 4px !important;
  }
  
  .ant-card-extra .ant-btn {
    width: 100%;
    justify-content: center;
  }
}

/* 加载状态改进 */
.ant-btn-loading .ant-btn-loading-icon {
  animation: loadingCircle 1s infinite linear;
}

@keyframes loadingCircle {
  100% {
    transform: rotate(360deg);
  }
}

/* 删除和重新生成按钮的特殊样式 */
.ant-btn[style*="color: #ff4d4f"]:hover {
  background: rgba(255, 77, 79, 0.1);
  border-color: #ff4d4f;
}

.ant-btn[style*="color: #1890ff"]:hover {
  background: rgba(24, 144, 255, 0.1);
  border-color: #1890ff;
}

/* 模态框样式改进 */
.ant-modal-confirm .ant-modal-body {
  padding: 24px;
}

.ant-modal-confirm .ant-modal-confirm-title {
  font-weight: 600;
  color: #262626;
}

.ant-modal-confirm .ant-modal-confirm-content {
  margin-top: 12px;
  color: #595959;
  line-height: 1.6;
}

/* 消息提示样式 */
.ant-message {
  z-index: 2000;
}

.ant-message-notice {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* 工具提示样式 */
.ant-tooltip {
  z-index: 1500;
}

.ant-tooltip-inner {
  border-radius: 6px;
  font-size: 12px;
  padding: 6px 8px;
}

/* 平滑滚动容器 */
.chat-container {
  scroll-behavior: smooth;
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

.chat-container::-webkit-scrollbar {
  width: 6px;
}

.chat-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.chat-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.chat-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 浮动滚动按钮动画 */
.scroll-to-bottom-btn {
  animation: fadeInUp 0.3s ease-out;
  transition: all 0.3s ease;
}

.scroll-to-bottom-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2) !important;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 防止内容跳动的样式 */
.content-stable {
  contain: layout style;
}

/* 代码块和图片的稳定渲染 */
.markdown-content img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 16px 0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.markdown-content pre {
  margin: 16px 0;
  overflow-x: auto;
}

/* 确保卡片内容稳定 */
.ant-card-body {
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/* 响应式滚动按钮 */
@media (max-width: 768px) {
  .scroll-to-bottom-btn {
    bottom: 60px !important;
    right: 20px !important;
    width: 45px !important;
    height: 45px !important;
  }
}

/* 防止ResizeObserver循环的优化 */
.ant-layout-sider {
  /* 使用transform代替width变化来减少重排 */
  transition: transform 0.3s ease, opacity 0.3s ease !important;
  will-change: transform;
  contain: layout style;
}

.ant-layout-content {
  /* 稳定内容布局 */
  contain: layout style;
  will-change: transform;
}

/* 移动端优化 */
@media (max-width: 768px) {
  .ant-layout-sider {
    /* 在移动端使用更平滑的动画 */
    transition: all 0.2s ease !important;
  }
  
  /* 减少移动端的重排 */
  .ant-card {
    contain: layout style;
  }
  
  /* 优化移动端滚动性能 */
  .chat-container {
    -webkit-overflow-scrolling: touch;
    transform: translateZ(0);
  }
}

/* 防止不必要的重绘 */
.ant-menu-item, .ant-menu-submenu {
  contain: layout style;
  backface-visibility: hidden;
  transform: translateZ(0);
}

/* 优化Progress组件性能 */
.ant-progress {
  contain: layout style;
}

/* 减少卡片动画引起的重排 */
.ant-card {
  backface-visibility: hidden;
  transform: translateZ(0);
}

/* 优化响应式组件 */
.responsive-container {
  contain: layout style;
  will-change: transform;
}

/* 防止布局抖动的通用样式 */
.stable-layout {
  contain: layout style;
  transform: translateZ(0);
  backface-visibility: hidden;
}

/* 优化媒体查询触发的性能 */
@media (max-width: 768px) {
  * {
    /* 在小屏幕上减少动画以提高性能 */
    animation-duration: 0.2s !important;
    transition-duration: 0.2s !important;
  }
}

/* 防止ResizeObserver在特定元素上循环 */
.resize-observer-safe {
  /* 使用较少触发重排的属性 */
  contain: size layout style;
  overflow: hidden;
}

/* 优化布局稳定性 */
.layout-stable {
  position: relative;
  contain: layout;
  min-height: 0;
  min-width: 0;
}

/* Chat容器的特殊优化 */
.chat-layout-container {
  contain: layout style;
  transform: translateZ(0);
  backface-visibility: hidden;
  /* 防止内容变化引起的抖动 */
  min-height: calc(100vh - 128px);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,YAAY;AACZ;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA,qCAAqC;AACrC;EACE,iDAAiD;AACnD;;AAEA;EACE,uCAAuC;EACvC,sDAAsD;AACxD;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA,yBAAyB;AACzB;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,yEAAyE;EACzE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,yBAAyB;AACzB;EACE,oDAAoD;EACpD,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;AACvD;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,yBAAyB;AACzB;;EAEE,6CAA6C;AAC/C;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA,aAAa;AACb;EACE,oDAAoD;EACpD,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,aAAa;AACb;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,aAAa;AACb;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,aAAa;AACb;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA,aAAa;AACb;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA,UAAU;AACV;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA,WAAW;AACX;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,mBAAmB;AACnB;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA,WAAW;AACX;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,uBAAuB;EACvB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,cAAc;AACd;EACE,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE;IACE,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA,0BAA0B;AAC1B;EACE,8BAA8B;EAC9B,6DAA6D;EAC7D,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,UAAU;AACV;EACE;IACE,iBAAiB;IACjB,oCAAoC;EACtC;;EAEA,aAAa;EACb;IACE,qBAAqB;EACvB;;EAEA,cAAc;EACd;IACE,iCAAiC;IACjC,wBAAwB;EAC1B;AACF;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE;IACE,mBAAmB;IACnB,mCAAmC;IACnC,oCAAoC;EACtC;AACF;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,wBAAwB;EACxB,2BAA2B;EAC3B,gBAAgB;EAChB,+BAA+B;AACjC","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n.ant-menu-item {\n  white-space: normal !important;\n  height: auto !important;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* App.css */\n.login-form {\n  max-width: 300px;\n}\n\n.login-form .login-form-forgot {\n  float: right;\n}\n\n.ant-col-rtl .login-form .login-form-forgot {\n  float: left;\n}\n\n.login-form .login-form-button {\n  width: 100%;\n}\n\n.mainContainer {\n  flex-direction: column;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n}\n\n.inputContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.inputBox {\n  height: 48px;\n  width: 400px;\n  font-size: large;\n  border-radius: 8px;\n  border: 1px solid grey;\n  padding-left: 8px;\n}\n\n/* Typing indicator animation */\n.typing-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n.typing-indicator span {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: #1890ff;\n  animation: typing 1.4s infinite ease-in-out;\n}\n\n.typing-indicator span:nth-child(1) {\n  animation-delay: -0.32s;\n}\n\n.typing-indicator span:nth-child(2) {\n  animation-delay: -0.16s;\n}\n\n@keyframes typing {\n  0%, 80%, 100% {\n    transform: scale(0.8);\n    opacity: 0.5;\n  }\n  40% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* Card hover effects */\n.ant-card {\n  transition: all 0.3s ease;\n}\n\n.ant-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1) !important;\n}\n\n/* Course selection card animations */\n.course-card {\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.course-card:hover {\n  transform: translateY(-8px) scale(1.02);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;\n}\n\n/* Smooth scrolling */\nhtml {\n  scroll-behavior: smooth;\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* Button animations */\n.ant-btn {\n  transition: all 0.3s ease;\n}\n\n.ant-btn:hover {\n  transform: translateY(-1px);\n}\n\n/* Responsive improvements */\n@media (max-width: 768px) {\n  .ant-card {\n    margin-bottom: 16px;\n  }\n  \n  .ant-space-item {\n    margin-bottom: 8px !important;\n  }\n}\n\n/* Gradient text effect */\n.gradient-text {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Loading shimmer effect */\n.shimmer {\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: shimmer 2s infinite;\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n/* Enhanced menu styles */\n.ant-menu-dark .ant-menu-item-selected {\n  background-color: rgba(24, 144, 255, 0.2) !important;\n  border-radius: 6px;\n  margin: 4px 8px;\n  width: calc(100% - 16px);\n}\n\n.ant-menu-dark .ant-menu-item {\n  margin: 2px 8px;\n  width: calc(100% - 16px);\n  border-radius: 6px;\n  transition: all 0.3s ease;\n}\n\n.ant-menu-dark .ant-menu-item:hover {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n/* Progress bar enhancements */\n.ant-progress-bg {\n  transition: all 0.3s ease;\n}\n\n/* Enhanced breadcrumb */\n.ant-breadcrumb a {\n  transition: color 0.3s ease;\n}\n\n.ant-breadcrumb a:hover {\n  color: #1890ff !important;\n}\n\n/* Card content spacing */\n.ant-card-body p:last-child {\n  margin-bottom: 0;\n}\n\n/* Enhanced select dropdown */\n.ant-select-dropdown {\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n/* Enhanced input focus */\n.ant-input:focus,\n.ant-input-focused {\n  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);\n}\n\n/* Enhanced button group */\n.ant-btn-group .ant-btn {\n  margin-right: 8px;\n}\n\n.ant-btn-group .ant-btn:last-child {\n  margin-right: 0;\n}\n\n/* 重新生成按钮样式 */\n.ant-card-extra .ant-btn {\n  transition: all 0.3s ease;\n}\n\n.ant-card-extra .ant-btn:hover {\n  transform: scale(1.1);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n/* 聊天卡片悬停效果 */\n.ant-card:hover {\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;\n  transform: translateY(-2px);\n  transition: all 0.3s ease;\n}\n\n/* 用户消息卡片样式 */\n.ant-card[style*=\"background: #f6ffed\"] {\n  border-left: 4px solid #52c41a;\n  transition: all 0.3s ease;\n}\n\n.ant-card[style*=\"background: #f6ffed\"]:hover {\n  border-left-width: 6px;\n  transform: translateX(2px);\n}\n\n/* AI回复卡片样式 */\n.ant-card[style*=\"border: 1px solid #f0f0f0\"] {\n  border-left: 4px solid #1890ff;\n  transition: all 0.3s ease;\n}\n\n.ant-card[style*=\"border: 1px solid #f0f0f0\"]:hover {\n  border-left-width: 6px;\n  transform: translateX(2px);\n}\n\n/* 问题输入区域样式 */\n.ant-card[style*=\"border: 2px dashed #d9d9d9\"] {\n  transition: all 0.3s ease;\n}\n\n.ant-card[style*=\"border: 2px dashed #d9d9d9\"]:hover {\n  border-color: #1890ff;\n  background: #f0f8ff !important;\n}\n\n/* 自动保存按钮样式 */\n.ant-btn[style*=\"color: #52c41a\"] {\n  border-color: #52c41a;\n  background: rgba(82, 196, 26, 0.1);\n}\n\n/* 控制面板样式增强 */\n.ant-card[style*=\"marginBottom: 24\"] {\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  border: none;\n}\n\n/* 响应式改进 */\n@media (max-width: 768px) {\n  .ant-card-extra {\n    margin-top: 8px;\n  }\n  \n  .ant-card-extra .ant-space {\n    flex-direction: column;\n    gap: 4px !important;\n  }\n  \n  .ant-card-extra .ant-btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n/* 加载状态改进 */\n.ant-btn-loading .ant-btn-loading-icon {\n  animation: loadingCircle 1s infinite linear;\n}\n\n@keyframes loadingCircle {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* 删除和重新生成按钮的特殊样式 */\n.ant-btn[style*=\"color: #ff4d4f\"]:hover {\n  background: rgba(255, 77, 79, 0.1);\n  border-color: #ff4d4f;\n}\n\n.ant-btn[style*=\"color: #1890ff\"]:hover {\n  background: rgba(24, 144, 255, 0.1);\n  border-color: #1890ff;\n}\n\n/* 模态框样式改进 */\n.ant-modal-confirm .ant-modal-body {\n  padding: 24px;\n}\n\n.ant-modal-confirm .ant-modal-confirm-title {\n  font-weight: 600;\n  color: #262626;\n}\n\n.ant-modal-confirm .ant-modal-confirm-content {\n  margin-top: 12px;\n  color: #595959;\n  line-height: 1.6;\n}\n\n/* 消息提示样式 */\n.ant-message {\n  z-index: 2000;\n}\n\n.ant-message-notice {\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n/* 工具提示样式 */\n.ant-tooltip {\n  z-index: 1500;\n}\n\n.ant-tooltip-inner {\n  border-radius: 6px;\n  font-size: 12px;\n  padding: 6px 8px;\n}\n\n/* 平滑滚动容器 */\n.chat-container {\n  scroll-behavior: smooth;\n  scrollbar-width: thin;\n  scrollbar-color: #c1c1c1 #f1f1f1;\n}\n\n.chat-container::-webkit-scrollbar {\n  width: 6px;\n}\n\n.chat-container::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 3px;\n}\n\n.chat-container::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 3px;\n}\n\n.chat-container::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* 浮动滚动按钮动画 */\n.scroll-to-bottom-btn {\n  animation: fadeInUp 0.3s ease-out;\n  transition: all 0.3s ease;\n}\n\n.scroll-to-bottom-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2) !important;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* 防止内容跳动的样式 */\n.content-stable {\n  contain: layout style;\n}\n\n/* 代码块和图片的稳定渲染 */\n.markdown-content img {\n  max-width: 100%;\n  height: auto;\n  display: block;\n  margin: 16px 0;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.markdown-content pre {\n  margin: 16px 0;\n  overflow-x: auto;\n}\n\n/* 确保卡片内容稳定 */\n.ant-card-body {\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n/* 响应式滚动按钮 */\n@media (max-width: 768px) {\n  .scroll-to-bottom-btn {\n    bottom: 60px !important;\n    right: 20px !important;\n    width: 45px !important;\n    height: 45px !important;\n  }\n}\n\n/* 防止ResizeObserver循环的优化 */\n.ant-layout-sider {\n  /* 使用transform代替width变化来减少重排 */\n  transition: transform 0.3s ease, opacity 0.3s ease !important;\n  will-change: transform;\n  contain: layout style;\n}\n\n.ant-layout-content {\n  /* 稳定内容布局 */\n  contain: layout style;\n  will-change: transform;\n}\n\n/* 移动端优化 */\n@media (max-width: 768px) {\n  .ant-layout-sider {\n    /* 在移动端使用更平滑的动画 */\n    transition: all 0.2s ease !important;\n  }\n  \n  /* 减少移动端的重排 */\n  .ant-card {\n    contain: layout style;\n  }\n  \n  /* 优化移动端滚动性能 */\n  .chat-container {\n    -webkit-overflow-scrolling: touch;\n    transform: translateZ(0);\n  }\n}\n\n/* 防止不必要的重绘 */\n.ant-menu-item, .ant-menu-submenu {\n  contain: layout style;\n  backface-visibility: hidden;\n  transform: translateZ(0);\n}\n\n/* 优化Progress组件性能 */\n.ant-progress {\n  contain: layout style;\n}\n\n/* 减少卡片动画引起的重排 */\n.ant-card {\n  backface-visibility: hidden;\n  transform: translateZ(0);\n}\n\n/* 优化响应式组件 */\n.responsive-container {\n  contain: layout style;\n  will-change: transform;\n}\n\n/* 防止布局抖动的通用样式 */\n.stable-layout {\n  contain: layout style;\n  transform: translateZ(0);\n  backface-visibility: hidden;\n}\n\n/* 优化媒体查询触发的性能 */\n@media (max-width: 768px) {\n  * {\n    /* 在小屏幕上减少动画以提高性能 */\n    animation-duration: 0.2s !important;\n    transition-duration: 0.2s !important;\n  }\n}\n\n/* 防止ResizeObserver在特定元素上循环 */\n.resize-observer-safe {\n  /* 使用较少触发重排的属性 */\n  contain: size layout style;\n  overflow: hidden;\n}\n\n/* 优化布局稳定性 */\n.layout-stable {\n  position: relative;\n  contain: layout;\n  min-height: 0;\n  min-width: 0;\n}\n\n/* Chat容器的特殊优化 */\n.chat-layout-container {\n  contain: layout style;\n  transform: translateZ(0);\n  backface-visibility: hidden;\n  /* 防止内容变化引起的抖动 */\n  min-height: calc(100vh - 128px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
